import {AssessmentTokenService} from '../../shared/services/assessment-token.service';
import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { AssessmentGroupService } from '../../shared/services/assessment-group.service';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { AuthService } from 'app/login/services/auth.service';
import { User } from 'app/shared/models/user';
import { Capability } from 'app/shared/models/capability';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'dac-assessment-tokens-list',
  templateUrl: './assessment-tokens-list.component.html',
  styleUrls: ['./assessment-tokens-list.component.css']
})
export class AssessmentTokensListComponent implements OnInit,OnDestroy {

  public tokenItems:{name:string, quantity:number}[];
  public groupTokenItems:{name:string, quantity:number}[];
  private canShop:Boolean;
  private _loaded:boolean;
  private _userSubscription:ISubscription;
  @Output() buy = new EventEmitter<{name:string, quantity:number}>();

  constructor(private tokenService:AssessmentTokenService
  ,private assessmentGroupService:AssessmentGroupService
  ,private assessmentService:AssessmentService
  ,private authService:AuthService) { 
    this._loaded = false;
    this.canShop = false;

    this._userSubscription = this.authService.getLoginState().subscribe(loginState =>{
      if (loginState.user) {
        this.canShop = loginState.user.hasCapability(Capability.CAN_SHOP);
      }
      else {
        this.canShop = false;
      }
    });
  }

  ngOnInit() {
    this._loaded = false;
    Promise.all([
      this.tokenService.loadAssessmentTokens()
      ,this.assessmentGroupService.getAssessmentGroups()
      ,this.assessmentService.getAssessmentList()
      ,
    ])
    .then((results) => {
      let [, groups, assessments] = results;
      this.groupTokenItems = groups.map(g => {return {name: g.Name, quantity: this.tokenService.getGroupRemainingTokens(g)} });
      this.tokenItems= assessments.map(a => {return {name: a.name, quantity: this.tokenService.getRemainingTokens(a)};});
      this._loaded = true;
    })
    .catch(error => {
      console.error(error);
      this._loaded = true;
    })
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }

  public get loaded() {
    return this._loaded;
  }

  triggerBuy(item:{name:string, quantity:number}) {
    this.buy.emit(item);
  }

  public shouldBuyTokens(item) {
    return this.canShop && item.quantity <= 0
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-tokens-list/assessment-tokens-list.component.ts